import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { verifyTokenGuard } from '@services/auth/verifyToken.guard';
import { setPasswordGuard } from '@services/auth/set-password.guard';
import { PermissionGuard } from '@services/auth/permission.guard';

export const routes: Routes = [
  { path: 'auth/login', component: Login },
  {
    path: 'set-password',
    canActivate: [verifyTokenGuard],
    loadComponent: async () => import('./pages/set-password/set-password').then((m) => m.SetPassword),
  },

  {
    path: '',
    canActivate: [setPasswordGuard],
    loadComponent: async () => import('./pages/page/page').then((m) => m.Page),
    children: [
      {
        path: 'home',
        loadComponent: async () => import('./pages/home/home').then((m) => m.Home),
      },

      {
        path: 'change-password',
        loadComponent: async () => import('./pages/change-password/change-password').then((m) => m.ChangePassword),
      },
      {
        path: 'dashboards',
        children: [
          {
            path: 'dashboard',
            loadComponent: async () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
          },
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'imports',
        children: [
          {
            path: 'shipments',
            canActivate: [PermissionGuard],
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/shipments/list/list').then((m) => m.List),
              },
              {
                path: ':id/show',
                loadComponent: async () => import('./pages/shipments/show/show').then((m) => m.Show),
              },
              {
                path: 'create',
                loadComponent: async () => import('./pages/shipments/create/create').then((m) => m.Create),
              },
              {
                path: ':id/update',
                loadComponent: async () => import('./pages/shipments/update/update').then((m) => m.Update),
              },
              {
                path: 'report',
                loadComponent: async () => import('./pages/inventory/inventory').then((m) => m.Inventory),
              },
              {
                path: 'wh-drayage/:id',
                loadComponent: async () => import('./pages/enter-bill/wh-drayage/create/create').then((m) => m.Create),
              },
              {
                path: 'wh-drayage/:id/:combined_id/show',
                loadComponent: async () => import('./pages/enter-bill/wh-drayage/show/show').then((m) => m.Show),
              },
              {
                path: 'wh-drayage/:id/:combined_id/update',
                loadComponent: async () => import('./pages/enter-bill/wh-drayage/update/update').then((m) => m.Update),
              },
              {
                path: 'warehouse/:id',
                loadComponent: async () => import('./pages/enter-bill/warehouse/create/create').then((m) => m.Create),
              },
              {
                path: 'warehouse/:id/:warehouse_id/show',
                loadComponent: async () => import('./pages/enter-bill/warehouse/show/show').then((m) => m.Show),
              },
              {
                path: 'warehouse/:id/:warehouse_id/update',
                loadComponent: async () => import('./pages/enter-bill/warehouse/update/update').then((m) => m.Update),
              },
              {
                path: 'drayage/:id',
                loadComponent: async () => import('./pages/enter-bill/drayage/create/create').then((m) => m.Create),
              },
              {
                path: 'drayage/:id/:drayage_id/show',
                loadComponent: async () => import('./pages/enter-bill/drayage/show/show').then((m) => m.Show),
              },
              {
                path: 'drayage/:id/:drayage_id/update',
                loadComponent: async () => import('./pages/enter-bill/drayage/update/update').then((m) => m.Update),
              },
            ],
          },
          {
            path: 'work-orders',
            canActivate: [PermissionGuard],
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/work-orders/list/list').then((m) => m.List),
              },
              {
                path: ':id/show',
                loadComponent: async () => import('./pages/work-orders/show/show').then((m) => m.Show),
              },
              {
                path: 'create',
                loadComponent: async () => import('./pages/work-orders/create/create').then((m) => m.Create),
              },
              {
                path: ':id/update',
                loadComponent: async () => import('./pages/work-orders/update/update').then((m) => m.Update),
              },
            ],
          },
          {
            path: 'receiving-reports',
            canActivate: [PermissionGuard],
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/receiving-reports/list/list').then((m) => m.List),
              },
              {
                path: ':id/show',
                loadComponent: async () => import('./pages/receiving-reports/show/show').then((m) => m.Show),
              },
              {
                path: 'create',
                loadComponent: async () => import('./pages/receiving-reports/create/create').then((m) => m.Create),
              },
              {
                path: ':id/update',
                loadComponent: async () => import('./pages/receiving-reports/update/update').then((m) => m.Update),
              },
            ],
          },
          {
            path: 'reports',
            loadComponent: async () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
          },
          {
            path: '',
            redirectTo: 'shipments',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'expenses',
        canActivate: [PermissionGuard],
        children: [
          {
            path: '',
            redirectTo: 'ap-product',
            pathMatch: 'full',
          },
          {
            path: 'ap-product',
            canActivate: [PermissionGuard],
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/ap-product/ap-product').then((m) => m.ApProduct),
              },
            ],
          },
          {
            path: 'list',
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/expenses/list/list').then((m) => m.List),
              },
            ],
          },
          {
            path: 'storage-warehouse',
            children: [
              {
                path: ':id/show',
                loadComponent: async () =>
                  import('./pages/expenses/storage-warehouse/_dialogs/edit-storage-warehouse-dialog/edit-storage-warehouse-dialog').then(
                    (m) => m.EditStorageWarehousePage,
                  ),
                data: { readOnly: true },
              },
              {
                path: ':id/update',
                loadComponent: async () =>
                  import('./pages/expenses/storage-warehouse/_dialogs/edit-storage-warehouse-dialog/edit-storage-warehouse-dialog').then(
                    (m) => m.EditStorageWarehousePage,
                  ),
              },
              {
                path: '',
                loadComponent: async () => import('./pages/expenses/storage-warehouse/storage-warehouse').then((m) => m.StorageWarehouse),
              },
            ],
          },
          {
            path: 'product-price',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'Product Price', apiPath: 'eb_product_price_items', includeItemFilters: true } },
          },
          {
            path: 'ocean-freight',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'Ocean Freight', apiPath: 'eb_ocean_freight_items', includeItemFilters: true } },
          },
          {
            path: 'duty-tax',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'Duty Tax', apiPath: 'eb_tax_free_items', includeItemFilters: true } },
          },
          {
            path: 'import-broker-fee',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'Import Broker Fee', apiPath: 'import_broker_items', includeItemFilters: true } },
          },
          {
            path: 'wh-drayage',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'WH/Drayage', apiPath: 'eb_combined_items', includeItemFilters: true } },
          },
          {
            path: 'initial-warehouse',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'Initial Warehouse', apiPath: 'eb_initial_warehouse_items', includeItemFilters: true } },
          },
          {
            path: 'drayage',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'Drayage', apiPath: 'eb_drayage_items', includeItemFilters: true } },
          },
          {
            path: 'trucking-bill',
            loadComponent: async () => import('./pages/expenses/item-report/item-report').then((m) => m.ExpenseItemReport),
            data: { reportConfig: { title: 'Trucking Bill', apiPath: 'truck_bill_items', includeItemFilters: false } },
          },
          {
            path: ':id/show',
            loadComponent: async () => import('./pages/expenses/show/show').then((m) => m.Show),
          },
          {
            path: 'create',
            loadComponent: async () => import('./pages/expenses/create/create').then((m) => m.Create),
          },
          {
            path: ':id/update',
            loadComponent: async () => import('./pages/expenses/update/update').then((m) => m.Update),
          },
        ],
      },

      {
        path: 'settings',
        children: [
          {
            path: 'users',
            canActivate: [PermissionGuard],
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/users/list/list').then((m) => m.List),
              },
              {
                path: ':id/show',
                loadComponent: async () => import('./pages/users/show/show').then((m) => m.Show),
              },
              {
                path: 'create',
                loadComponent: async () => import('./pages/users/create/create').then((m) => m.Create),
              },
              {
                path: ':id/update',
                loadComponent: async () => import('./pages/users/update/update').then((m) => m.Update),
              },
            ],
          },
          {
            path: '',
            redirectTo: 'users',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'inventories',
        canActivate: [PermissionGuard],
        children: [
          {
            path: 'inventory-adjustment',
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/inventory-adjustment/list/list').then((m) => m.List),
              },
              {
                path: 'create',
                loadComponent: async () => import('./pages/inventory-adjustment/create/create').then((m) => m.Create),
              },
              {
                path: ':id/show',
                loadComponent: async () => import('./pages/inventory-adjustment/show/show').then((m) => m.Show),
              },
            ],
          },
          {
            path: 'stock-balance-report',
            loadComponent: async () => import('./pages/inventory/inventory').then((m) => m.Inventory),
            children: [
              {
                path: 'inventory-costing',
                loadComponent: async () => import('./pages/inventory/inventory-costing/inventory-costing').then((m) => m.InventoryCosting),
              },
              {
                path: 'inventory',
                loadComponent: async () => import('./pages/inventory/inventory-stock/inventory-stock').then((m) => m.InventoryStock),
              },
              {
                path: '',
                redirectTo: 'inventory-costing',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'inventory-movment-report',
            loadComponent: async () => import('./pages/inventory-movement/inventory-movement').then((m) => m.InventoryMovement),
          },
          {
            path: '',
            redirectTo: 'stock-balance-report',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'sales',
        canActivate: [PermissionGuard],
        children: [
          {
            path: 'sale-order',
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/sale-order/list/list').then((m) => m.List),
              },
              {
                path: 'create',
                loadComponent: async () => import('./pages/sale-order/create/create').then((m) => m.Create),
              },
              {
                path: ':id/show',
                loadComponent: async () => import('./pages/sale-order/show/show').then((m) => m.Show),
              },
              {
                path: ':id/update',
                loadComponent: async () => import('./pages/sale-order/update/update').then((m) => m.Update),
              },
            ],
          },
          {
            path: 'sale-invoice',
            children: [
              {
                path: '',
                loadComponent: async () => import('./pages/sale-invoice/list/list').then((m) => m.List),
              },
              {
                path: 'create',
                loadComponent: async () => import('./pages/sale-invoice/create/create').then((m) => m.Create),
              },
              {
                path: ':id/create',
                loadComponent: async () => import('./pages/sale-invoice/create/create').then((m) => m.Create),
              },
              {
                path: ':id/show',
                loadComponent: async () => import('./pages/sale-invoice/show/show').then((m) => m.Show),
              },
              {
                path: ':id/update',
                loadComponent: async () => import('./pages/sale-invoice/update/update').then((m) => m.Update),
              },
            ],
          },
          {
            path: 'sale-report',
            loadComponent: async () => import('./pages/inventory-movement/inventory-movement').then((m) => m.InventoryMovement),
          },
          {
            path: 'cost-report',
            loadComponent: async () => import('./pages/cost-of-sale-report/cost-of-sale-report').then((m) => m.CostOfSaleReport),
          },
          {
            path: '',
            redirectTo: 'sale-order',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
];
